import React from 'react'

const Statement = () => {
  return (
    <div className="isave-statement">
      <h4>Statement of the problem</h4>
      <p>
        The Fintech industry is ever increasing in Africa but little focus has been paid to savings and investments platforms which means the public isnt used to them and doubt the advantages of such platforms.
        Most people and establishments prefer the use of banks to save their funds which secure but provide little or no interest on the funds. The goal is to attract target users from bank saving to the Isave app.
        <br />
        <br />
        <strong>User research done</strong> in line with personalities in the user personas led to the discovery of some major challenges that the Isave app needs to solve for wide adoption and smooth user experience.
        <br />
        <br />
      </p>
      <ol>
        <li><p>Users need to be able to distribute their savings into different sections.</p></li>
        <li><p>The process of depositing must be fast and easy to use.</p></li>
        <li><p>Withdrawals should be easily accessible and must not be cubersome to withdraw funds.</p></li>
        <li><p>Users need to be able to save and earn at the same time</p></li>
        <li><p>Detailed Information about the investment compnies should be vailable for users to evaluate them before investing with them.</p></li>
        <li><p>Ready to access customer support services.</p></li>
      </ol>
    </div>
  )
}

export default Statement